import React, {Component} from 'react'
import PropTypes from 'prop-types'
import NavBar from '../components/NavBar/NavBar'
import './index.css'
import Footer from "../components/Footer/Footer";
import SEO from "../components/SEO/SEO";

class Index extends Component {
    render() {
        const {children} = this.props;
        const {slug, footer, job} = this.props.data;
        const jobOpening = job.edges.map(i => i.node.acf.page_active === true);
        return (
          <div>
              <SEO/>
              <NavBar
                slug={slug.edges}
                jobOpening={jobOpening[0]}
              />
              {children()}
              <Footer footer={footer.edges}/>
          </div>
        )
    }
}

Index.propTypes = {
    children: PropTypes.func,
};

export default Index


export const navQuery = graphql`
  query navQuery {
    slug: allWordpressPost(filter: {acf: {type: {eq: "product"}}}, sort: {fields: [date]}) {
    edges {
      node {
        slug
        acf {
          title
        }
      }
    }
  }
  footer: allWordpressPage(filter: {title: {eq: "Footer"}}) {
    edges {
      node {
        id
        title
        acf {
          phone
          email
          location
        }
      }
    }
  }
      job: allWordpressPage(filter: {title: {eq: "JOIN OUR TEAM"} }){
        edges{
            node{
                acf{
                    page_active
                }
            }
        }
    }
}`;



// WEBPACK FOOTER //
// ./src/layouts/index.js